// Landing: feature ticker pinned to the bottom of the screen, styled like a
// system status bar. Decorative (aria-hidden); the same features are in the page.
import React from 'react';
import './Ticker.css';

const ITEMS = [
  'STUDIO', 'PHOTO TO 3D AVATAR', 'SPATIAL VOICE', 'SCREEN SHARE', '8 MULTIPLAYER GAMES', 'LEADERBOARDS',
  'DRAG-AND-DROP BUILDER', 'SKYBOXES', 'PORTALS', 'MARKETPLACE', 'BLENDER + UNITY IMPORT', 'WEBXR', 'HAND TRACKING', 'MCP / AI ASSISTANTS',
];

const Ticker: React.FC = () => (
  <div className="tk" aria-hidden="true">
    <div className="tk-status"><i />SYS.ONLINE</div>
    <div className="tk-window">
      <div className="tk-track">
        {[...ITEMS, ...ITEMS].map((t, i) => (
          <span key={i}><b>{String((i % ITEMS.length) + 1).padStart(2, '0')}</b>{t}<em>//</em></span>
        ))}
      </div>
    </div>
    <div className="tk-build">v.BETA · WEBXR READY</div>
  </div>
);

export default Ticker;
